import { createAmerAPI } from '../api/amerAPI';

let injectedClient = null;
let currentBaseUrl = null;

/**
 * Sets the API client instance
 * @param {import('axios').AxiosInstance} client - Axios instance to use
 */
export function setApiClient(client) {
  injectedClient = client;
}

/**
 * Sets the base URL for API calls and creates/get API client
 * @param {string} baseUrl - Base URL for the API
 * @returns {import('axios').AxiosInstance} - API client instance
 */
export function setApiClientBaseUrl(baseUrl) {
  if (currentBaseUrl !== baseUrl) {
    injectedClient = createAmerAPI(baseUrl);
    currentBaseUrl = baseUrl;
  }
  return injectedClient;
}

/**
 * Gets the API client instance
 * @param {string} [baseUrl] - Optional base URL. If provided and different from current, creates new client
 * @returns {import('axios').AxiosInstance} - API client instance
 */
export default function getApiClient(baseUrl) {
  if (baseUrl) {
    return setApiClientBaseUrl(baseUrl);
  }
  
  if (!injectedClient) {
    throw new Error('API client not initialized. Call setApiClient() or setApiClientBaseUrl() first.');
  }
  
  return injectedClient;
}
